import secureRequest from "@toothfairy/shared-api/secureAPI";
import envConfig from "../../../envConfig";
import client from "@toothfairy/shared-api/src/Common/client";

const getSSOproviderName = async (domain) => {
  headers = { "x-api-key": envConfig.REACT_APP_SSO_TOKEN };
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/workspaces/getSSOproviderByDomain?domain=${domain}`;
  return secureRequest(client, "GET", url, null, null, false, headers);
};

export default {
  getSSOproviderName,
};
